export enum AdminDictionaryListItemAction {
  Edit,
  Remove,
}
